<template>
    <div v-if="images"
        class="owl-carousel"
        :id="['owl-' + unitid + carouselno]">
        <div v-for="img in images"
            class="item">
            <img-fallback :img="img.id"
                mode="img"
                img-format="m"
                vo-msg:placeholder="no.pic.placeholder"></img-fallback>

        </div>
    </div>
    <div v-else>
        <img-fallback mode="img"
            vo-msg:placeholder="no.pic.placeholder"></img-fallback>
    </div>
</template>

<script>
    import V from 'voUtils/V.js'



    export default {
    	voVueComponent: 'static-img-carousel',
    	props: {
    		images: Array,
    		default: () => [{
    			id: -1,
    			width: 450,
    			height: 300,
    			name: '//placehold.it/450x300&text=No Image'
    		}],
    		unitid: Number,
    		carouselno: String,
    		unitpath: String

    	},

    	mounted: function() {
    		$("#owl-" + this.unitid + '' + this.carouselno).owlCarousel({
    			items: 1,
    			loop: true,
    			center: false,
    			autoplay: false,
    			smartSpeed: 1000,
    			dots: true,
    			nav: true
    		});
    	}
    };
</script>